import { Log } from 'ng2-logger';
import ApiClient from './alms-api';
import Translator from '../core/i18n';
const _logger = Log.create('Background-Service');
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();

export class ActivityMultiplyService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetActivityCopyDatasAsync(params: any) {
        const requestUrl = `api/course/teachercourses`;

        return _apiClient
            .RequestAsync('POST', requestUrl, params, '', false)
            .then((responseData: any) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }
    public async RequestGetActivityListDatasAsync(params: any){
        const query = `${params.CourseId}/${params.ClassId}?termWeekId=${params.TermWeekId ? params.TermWeekId : 0}&weekZero=${params.weekZero}&isWeekly=${params.IsWeekly}&take=${params.Take}&skip=${params.Skip}&orderBy=${params.OrderBy}`;
        const requestUrl = `api/activity/byweekactivity/` + query;

        return _apiClient
            .RequestAsync('GET', requestUrl, null, token)
            .then((responseData: any) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestGetStartActivityMultiplyAsync(params: any){
        const requestUrl = `api/virtualclass/runmultiply`;

        return _apiClient
            .RequestAsync('POST', requestUrl, params, '', false)
            .then((responseData: any) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestAcitivityMultiplyDataAsync(params: any){
        const query = `?activityId=${params.activityId}`;

        const requestUrl = `api/virtualclass/multiplydata` + query;

        return _apiClient
            .RequestAsync('GET', requestUrl, null, token)
            .then((responseData: any) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }
}
